// 事件名称

// 患者添加
export const PATIENT_ADDITION = 'patientAddition';

export const DEAL_VISIT_SELECT = 'dealVisitSelect';

export const RETRY_SEND_MSG = 'retrySendMsg';

// 填写问卷
export const FILL_OUT_QUESTIONNAIRE = 'fillOutQuestionnaire';

// 计划 导入患者更新数据
export const PLAN_PATIENT_UPDATE = 'planPatientUpdate';
